import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Immutable from 'immutable';
import DocketHeader from './DocketHeader';
import DocketEntries from './docketEntries/DocketEntries';
import DocketsPaginator from './DocketsPaginator';
import UpdateRedact from './UpdateRedact';
import SearchReceipt from '../../search/results/searchReceipt/SearchReceipt';
import MissingEntriesTooltip from './MissingEntriesTooltip';
import LastFilingTooltip from './LastFilingTooltip';

class DocketsTable extends Component {
  render() {
    const {
      DocketsPopupComponentType,
      docketEntriesProps,
      showMissingDockets,
      docketsPaginatorProps,
      header,
      lastUpdated,
      error,
      receipt,
      popup,
      showPacerSearchBarClassName,
      collapseHeader,
      showRedactPopup,
      closeRedactPopup,
      redact,
      reloadDetails,
      onPopupClick,
    } = this.props;

    return (
      <div id="dockets-tabs" className="dockets-table">
        <div className={showPacerSearchBarClassName}>
          {showMissingDockets && <MissingEntriesTooltip />}

          {header.hasMoreRecentFilingsDate && <LastFilingTooltip date={header.latest_known_date_filed} />}

          <DocketHeader open={!collapseHeader} data={header} lastUpdated={lastUpdated} />

          <DocketEntries {...docketEntriesProps} />

          <DocketsPaginator {...docketsPaginatorProps} />

          {!_.isEmpty(receipt) && <SearchReceipt receipt={Immutable.fromJS({ text: receipt })} />}

          <UpdateRedact showRedactPopup={showRedactPopup} closeRedactPopup={closeRedactPopup} redact={redact} />

          {DocketsPopupComponentType && (
            <DocketsPopupComponentType onClose={onPopupClick} info={popup} reloadDetails={reloadDetails} />
          )}
        </div>
      </div>
    );
  }
}

DocketsTable.defaultProps = {
  receipt: null,
  showMissingDockets: false,
};

DocketsTable.propTypes = {
  DocketsPopupComponentType: PropTypes.any.isRequired,
  docketFilterProps: PropTypes.object.isRequired,
  docketEntriesProps: PropTypes.object.isRequired,
  showMissingDockets: PropTypes.bool,
  header: PropTypes.object.isRequired,
  docketsPaginatorProps: PropTypes.object.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  error: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  popup: PropTypes.any.isRequired,
  showPacerSearchBarClassName: PropTypes.string.isRequired,
  collapseHeader: PropTypes.bool.isRequired,
  showRedactPopup: PropTypes.bool.isRequired,
  closeRedactPopup: PropTypes.func.isRequired,
  redact: PropTypes.func.isRequired,
  reloadDetails: PropTypes.func.isRequired,
  onPopupClick: PropTypes.func.isRequired,
};

export default DocketsTable;



// WEBPACK FOOTER //
// ./src/components/case/docket/DocketsTable.jsx